import axios from 'axios'
import store from './store'

const axiosInstance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: IS_SERVER ? context.apiUrl : window.appContext.apiUrl,
  responseType: 'json',
  onDownloadProgress: (event) => {
    store.commit('setPreloaderPercentage', (event.loaded/event.total) * 100)
  }
})

// register preloader interceptors, only on client-side
if (!IS_SERVER) {
  let preloaderUpdateInterval = null
  const preloaderUpdate = () => {
    store.commit('setPreloaderPercentage', store.state.preloader.percentage + 10)
  }
  
  axiosInstance.interceptors.request.use(config => {
    store.commit('setPreloaderPercentage', 0)
    
    setTimeout(() => store.commit('setPreloaderVisible', true), 100)
    setTimeout(() => store.commit('setPreloaderPercentage', 20), 100)
  
    preloaderUpdateInterval = setInterval(preloaderUpdate, 1000)
  
    return config
  }, err => Promise.reject(err))
  
  axiosInstance.interceptors.response.use(response => {
    store.commit('setPreloaderPercentage', 100)
  
    setTimeout(() => store.commit('setPreloaderVisible', false), 450)
    setTimeout(() => {
      store.commit('setPreloaderPercentage', 0)
    }, 900)
    clearInterval(preloaderUpdateInterval)
    preloaderUpdateInterval = null
  
    return response
  }, err => {

    store.commit('setPreloaderVisible', false)
    setTimeout(() => {
      store.commit('setPreloaderPercentage', 0)
    }, 900)

    clearInterval(preloaderUpdateInterval)
    preloaderUpdateInterval = null
  
    return Promise.reject(err)
  })  
}

const getFilm = (slug) => {
  return axiosInstance.get(`films/${slug}`)
}

export {
  getFilm
}
